"use client";

import { Star } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Testimonials() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: cardsRef,
    isVisible: cardsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const testimonials = [{
    quote: "Sunil transformed our OTA strategy, resulting in a",
    accent: "30% revenue",
    tail: " boost within the first quarter. Truly expert.",
    name: "SARAH J.",
    meta: "GM, GRAND PLAZA • NOV 2024",
    offset: false
  }, {
    quote: "His deep knowledge of tech stacks and revenue",
    accent: "audits",
    tail: " saved us thousands in wasted software costs.",
    name: "DAVID K.",
    meta: "OWNER, CITY SUITES • OCT 2024",
    offset: true
  }, {
    quote: "A hands-on approach that solved our demand",
    accent: "challenges",
    tail: " with precision and data-driven insights.",
    name: "ELENA M.",
    meta: "INVESTOR, COASTAL RESORTS • SEP 2024",
    offset: false
  }];
  return <section data-section-id="1657" id="testimonialscasestudies" className="bg-background text-foreground relative overflow-hidden py-24 md:py-32">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute right-4 top-12 select-none font-serif font-light leading-none text-foreground/[0.03] md:right-12 md:top-20" style={{
      fontSize: "28vw"
    }}>
        03
      </div>

      <div className="relative mx-auto max-w-[1440px] px-6 md:px-22">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-8">
          {}
          <div ref={headerRef} className={`lg:col-span-7 transition-all duration-[800ms] ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          transitionTimingFunction: "cubic-bezier(0.2, 0.8, 0.2, 1)"
        }}>
            {}
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2">
                <span className="h-px w-12 bg-primary" />
                <span className="h-1 w-1 bg-primary" />
              </div>
              <span className="font-mono text-[0.78rem] uppercase text-primary" style={{
              letterSpacing: "0.18em"
            }}>
                § 03 / CLIENT — SUCCESS STORIES
              </span>
            </div>

            {}
            <h2 className="mt-8 font-serif font-light text-foreground" style={{
            fontSize: "clamp(2.25rem, 5.4vw, 4.75rem)",
            lineHeight: "1.0",
            letterSpacing: "-0.02em"
          }}>
              Proven{" "}
              <span className="italic text-primary">Results</span>
            </h2>

            {}
            <p className="mt-8 max-w-xl font-serif text-foreground/85" style={{
            fontSize: "clamp(1.0625rem, 1.2vw, 1.25rem)",
            lineHeight: "1.6"
          }}>
              Helping hotel owners and investors maximize revenue through 
              data-driven strategies and expert technical guidance.
            </p>

            {}
            <div className="mt-12 flex flex-wrap items-center gap-x-6 gap-y-4 border-t border-border pt-8">
              <div className="flex items-center gap-3">
                <span className="font-mono font-medium text-foreground" style={{
                fontSize: "1.5rem",
                letterSpacing: "0.05em"
              }}>
                  5.0
                </span>
                <div className="flex items-center gap-1">
                  {[0, 1, 2, 3, 4].map(i => <Star key={i} data-index={i} className="h-4 w-4 fill-primary text-primary" strokeWidth={1.25} />)}
                </div>
              </div>
              <span className="h-4 w-px bg-border" />
              <span className="font-mono text-[0.78rem] uppercase text-muted-foreground" style={{
              letterSpacing: "0.16em"
            }}>
                50+ PROJECTS
              </span>
              <span className="h-4 w-px bg-border" />
              <span className="font-mono text-[0.78rem] uppercase text-muted-foreground" style={{
              letterSpacing: "0.16em"
            }}>
                VERIFIED EXPERT
              </span>
            </div>
          </div>

          {}
          <div ref={cardsRef} className="lg:col-span-5">
            <div className="flex flex-col gap-6">
              {testimonials.map((t, i) => <div key={i} data-index={i} className={`group relative bg-card border border-border p-8 transition-all duration-[800ms] ease-out hover:border-primary ${cardsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"} ${t.offset ? "lg:-ml-4" : ""}`} style={{
              transitionDelay: cardsVisible ? `${i * 120}ms` : "0ms",
              transitionTimingFunction: "cubic-bezier(0.2, 0.8, 0.2, 1)"
            }}>
                  {}
                  <span aria-hidden="true" className="absolute left-2 top-2 h-3 w-3 opacity-60 transition-opacity duration-300 group-hover:opacity-100">
                    <span className="absolute left-0 top-1/2 h-px w-3 bg-primary" />
                    <span className="absolute left-1/2 top-0 h-3 w-px bg-primary" />
                  </span>
                  <span aria-hidden="true" className="absolute right-2 top-2 h-3 w-3 opacity-60 transition-opacity duration-300 group-hover:opacity-100">
                    <span className="absolute left-0 top-1/2 h-px w-3 bg-primary" />
                    <span className="absolute left-1/2 top-0 h-3 w-px bg-primary" />
                  </span>
                  <span aria-hidden="true" className="absolute bottom-2 left-2 h-3 w-3 opacity-60 transition-opacity duration-300 group-hover:opacity-100">
                    <span className="absolute left-0 top-1/2 h-px w-3 bg-primary" />
                    <span className="absolute left-1/2 top-0 h-3 w-px bg-primary" />
                  </span>
                  <span aria-hidden="true" className="absolute bottom-2 right-2 h-3 w-3 opacity-60 transition-opacity duration-300 group-hover:opacity-100">
                    <span className="absolute left-0 top-1/2 h-px w-3 bg-primary" />
                    <span className="absolute left-1/2 top-0 h-3 w-px bg-primary" />
                  </span>

                  {}
                  <div className="flex items-center gap-1">
                    {[0, 1, 2, 3, 4].map(s => <Star key={s} data-index={s} className="h-[14px] w-[14px] fill-primary text-primary" strokeWidth={1.25} />)}
                  </div>

                  {}
                  <p className="mt-6 font-serif font-normal text-foreground" style={{
                fontSize: "clamp(1.25rem, 1.9vw, 1.625rem)",
                lineHeight: "1.3",
                letterSpacing: "-0.015em"
              }}>
                    {t.quote}{" "}
                    <span className="italic text-primary transition-all duration-300 group-hover:brightness-125">
                      {t.accent}
                    </span>
                    {t.tail}
                  </p>

                  {}
                  <div className="mt-8 flex flex-col gap-1">
                    <span className="font-mono text-[0.78rem] uppercase text-foreground" style={{
                  letterSpacing: "0.16em"
                }}>
                      — {t.name}
                    </span>
                    <span className="font-mono text-[0.72rem] uppercase text-muted-foreground" style={{
                  letterSpacing: "0.14em"
                }}>
                      {t.meta}
                    </span>
                  </div>
                </div>)}
            </div>

            {}
            <div className="mt-10 flex justify-end">
              <Link to="/ContactPage" className="group inline-flex items-center gap-2 font-mono text-[0.78rem] uppercase text-primary" style={{
              letterSpacing: "0.16em"
            }}>
                <span className="relative">
                  BOOK A CONSULTATION
                  <span className="absolute -bottom-1 left-0 h-px w-3/5 bg-primary transition-all duration-[250ms] ease-out group-hover:w-full" />
                </span>
                <span aria-hidden="true">↗</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}